import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const ForbiddenPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: routesUrl.forbidden,
      component: React.lazy(() => import('./ForbiddenPage')),
    },
  ],
};

export default ForbiddenPageConfig;
